// Convert a local wall-clock release time ("HH:MM" on a "YYYY-MM-DD" date) to
// the "HH:MM UTC" format used by the event calendar. DST rules are computed,
// so the helpers work for any year without a timezone database.

function nthSundayUTC(year, month, n) {
  const first = new Date(Date.UTC(year, month, 1));
  const offset = (7 - first.getUTCDay()) % 7;
  return new Date(Date.UTC(year, month, 1 + offset + (n - 1) * 7));
}

function lastSundayUTC(year, month) {
  const last = new Date(Date.UTC(year, month + 1, 0));
  return new Date(Date.UTC(year, month, last.getUTCDate() - last.getUTCDay()));
}

// US DST: 2nd Sunday of March → 1st Sunday of November
export function isUsDst(date) {
  const d = new Date(date + 'T12:00:00Z');
  const y = d.getUTCFullYear();
  return d >= nthSundayUTC(y, 2, 2) && d < nthSundayUTC(y, 10, 1);
}

// EU/UK summer time: last Sunday of March → last Sunday of October
export function isEuDst(date) {
  const d = new Date(date + 'T12:00:00Z');
  const y = d.getUTCFullYear();
  return d >= lastSundayUTC(y, 2) && d < lastSundayUTC(y, 9);
}

function toUtc(localTime, utcOffsetHours) {
  const [h, m] = localTime.split(':').map(Number);
  const hh = (h - utcOffsetHours + 24) % 24;
  return `${String(hh).padStart(2, '0')}:${String(m).padStart(2, '0')} UTC`;
}

export const newYorkToUtc  = (date, t) => toUtc(t, isUsDst(date) ? -4 : -5);
export const londonToUtc   = (date, t) => toUtc(t, isEuDst(date) ? 1 : 0);
export const frankfurtToUtc = (date, t) => toUtc(t, isEuDst(date) ? 2 : 1);
